/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {InitiateIWYSOnboardingFlowRequest} from '@cash-web/protos/squareup/cash/investautomator/api/flows/initiateIWYSOnboardingFlow.pb'
import {InitiateIWYSOnboardingFlowResponse} from '@cash-web/protos/squareup/cash/investautomator/api/flows/initiateIWYSOnboardingFlow.pb'


export const initiateIWYSOnboardingFlow = (request:InitiateIWYSOnboardingFlowRequest, options?: CashRequestOptions) => post<InitiateIWYSOnboardingFlowRequest, InitiateIWYSOnboardingFlowResponse>("/2.0/cash/initiate-i-w-y-s-onboarding-flow", request, {...options, rejectOnError: true })